import React from "react";
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { FiChevronDown, FiCheck } from "react-icons/fi";
import { MdOutlineEditNote, MdOutlinePublic } from "react-icons/md";
import { BiErrorAlt } from "react-icons/bi";
import "./style.css";

const VARIANT_META = {
  draft: {
    icon: <MdOutlineEditNote />,
    description: "Save without publishing",
  },
  published: {
    icon: <MdOutlinePublic />,
    description: "Visible to all users",
  },
};

const getOptionMeta = (option) => ({
  ...option,
  ...(VARIANT_META[option.variant] || {}),
});

const StatusSelect = ({
  label,
  required = false,
  value,
  options = [],
  placeholder = "Select status",
  onChange,
  onBlur,
  error,
  disabled = false,
}) => {
  const selected = options
    .map(getOptionMeta)
    .find((option) => String(option.value) === String(value));
  const hasError = Boolean(error);
  const variant = selected?.variant || "empty";

  return (
    <div
      className={`status-select ${hasError ? "status-select--error" : ""} ${
        disabled ? "status-select--disabled" : ""
      }`}
    >
      {label ? (
        <label className="status-select__label">
          {label}
          {required ? <span className="status-select__required">*</span> : null}
        </label>
      ) : null}

      <CDropdown
        className="status-select__dropdown"
        variant="dropdown"
        alignment="start"
        portal
        popper
        popperConfig={{ strategy: "fixed" }}
        onHide={onBlur}
      >
        <CDropdownToggle
          caret={false}
          color="light"
          disabled={disabled}
          className={`status-select__toggle status-select__toggle--${variant}`}
        >
          <span className={`status-select__icon status-select__icon--${variant}`}>
            {selected?.icon || <MdOutlineEditNote />}
          </span>
          <span className="status-select__copy">
            <span
              className={
                selected
                  ? "status-select__value"
                  : "status-select__placeholder"
              }
            >
              {selected?.label || placeholder}
            </span>
          </span>
          <FiChevronDown className="status-select__caret" />
        </CDropdownToggle>

        <CDropdownMenu className="status-select__menu">
          {options.map((rawOption) => {
            const option = getOptionMeta(rawOption);
            const isActive = String(option.value) === String(value);

            return (
              <CDropdownItem
                as="button"
                type="button"
                key={String(option.value)}
                className={`status-select__option ${
                  isActive ? "is-active" : ""
                }`}
                onClick={() => onChange?.(String(option.value))}
              >
                <span
                  className={`status-select__icon status-select__icon--${option.variant}`}
                >
                  {option.icon}
                </span>
                <span className="status-select__option-copy">
                  <span className="status-select__option-label">
                    {option.label}
                  </span>
                  {option.description ? (
                    <span className="status-select__option-hint">
                      {option.description}
                    </span>
                  ) : null}
                </span>
                {isActive ? (
                  <FiCheck className="status-select__check" />
                ) : null}
              </CDropdownItem>
            );
          })}
        </CDropdownMenu>
      </CDropdown>

      {hasError ? (
        <p className="status-select__error">
          <BiErrorAlt />
          <span>{error}</span>
        </p>
      ) : null}
    </div>
  );
};

export default StatusSelect;
